import { Col, Row } from "reactstrap";
import ModalComponent from "../common/Modal/modal";
import { CustomButton } from "../../widgets";
import { useState } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import Dump from "./Dump";
import SurveyFormComponent from "../surveyForm/SurveyFormComponent";
import { getFormData, getFormVariables } from "./apiController";
import ViewForm from "./ViewForm";
import { useDispatch } from "react-redux";
import { setLoading } from "../../store/slices/auth";
import _, { cloneDeep } from "lodash";

const MasterData = (props) => {
     const { projectData, mdata, addAction, onAction, selectedIndexData, id, isMasterData, masterresponseData, responseData } = props;
     const [selectedRecord, setselectedRecord] = useState<any>();
     const [action, setAction] = useState<any>("");
     const [masterUidData, setMasterUidData] = useState<any>(null);
     const [customNavigationState, setCustomNavigationState] = useState<any>(null);
     const [formData, setformData] = useState<any>(null);
     const [formVariables, setformVariables] = useState<any>(null);
     const [selectedFormData, setSelectedFormData] = useState<any>(null);

     const dispatch = useDispatch();
     const formatDate = (isoString) => {
          const date = new Date(isoString);
          return date.toLocaleString("en-US", {
               weekday: "long",
               year: "numeric",
               month: "long",
               day: "numeric",
               hour: "2-digit",
               minute: "2-digit",
               second: "2-digit",
               //   timeZoneName: "short"
          });
     };

     const getViewData = (selected) => {
          let data = props;
          setselectedRecord(selected)

     }

     /**
     * on dump action
     */
     const dumpAction = (selectedData) => {
          const selectedForm = props?.forms?.find((form) => form.id === selectedData.form_id);
          setSelectedFormData(selectedForm);
          setAction("dump")
          let flt = props.selectedIndexData.cells.filter(itm => itm.column.data?.field_use_type?.includes('UID'));

          let uid_field = flt[0].column.data;
          const uidData = {
               master_uid: uid_field.field_selected_value,
               master_uid_field_id: uid_field.id
          }
          setMasterUidData(uidData);
     }

     //Get SourceUidField if present or first uid field
     const getSourceUidField = (fieldsData) => {
          const formid = id || props.formData?.id;
          let flt = fieldsData.filter(itm => itm?.field_use_type?.includes('UID'));
          const sourceUidField = flt.find(itm => formid === itm?.source_form_id);
          let finalUidField;
          if (sourceUidField) {
               finalUidField = sourceUidField;
          } else {
               finalUidField = flt[0]
          }
          return finalUidField;
     }

     /**
  * on add master action
  */
     const onAddAction = (formitm) => {
          const uidFieldData = getSourceUidField(selectedIndexData.original.fields);
          let data: any = {
               created_on: props.formData.created_on,
               form_name: formitm.form_name,
               id: formitm.form_id,
               total_responses: props.formData.total_responses,
               updated_on: props.formData.updated_on,
               uidData: uidFieldData,
               recordId : formitm.record_info[0] ? formitm.record_info[0].id : null
          };

          data.formsList = props.forms;
          data.projectData = props.projectData;
          data.isMaster = true;
          data.masterData = mdata;
          const state = { data, parentFormData: props.formData, projectData: props.projectData, isMaster: true, moduleType: "dataEntry"};
          setCustomNavigationState(state);
          setAction("navigateToDataEntry");
     }

     /**
      * on view action
      */
     const onViewAction = async (record, index) => {
          try {
               dispatch(setLoading(true));
               let response = await getFormVariables(record.form_id);
               if (response.data && record.record_info.length > 0) {
                    response.data.forEach((obj) => {
                         let selectedRecord = record.record_info[index].fields.filter(elem => elem.id === obj.id);

                         if (selectedRecord.length > 0) {
                              if (obj.field_type === 'dateField') {
                                   obj.selectedValue = new Date(selectedRecord[0].field_selected_value);
                              } else if (obj.field_type === 'dropDown') {
                                   obj.selectedValue = {
                                        label: selectedRecord[0].field_selected_value,
                                        value: selectedRecord[0].field_selected_value
                                   };
                              } else {
                                   obj.selectedValue = selectedRecord[0].field_selected_value;
                              }
                         }
                         obj.field_category = obj.field_category || 'empty';
                    });
                    let temp: any = _.groupBy(response.data, "field_category");
                    if (temp.empty) {
                         let data = cloneDeep(temp.empty);
                         delete temp.empty;
                         temp.empty = data;
                    }
                    let responseForm = await getFormData(record?.form_id);
                    setformData(responseForm?.data);
                    setformVariables(temp);
                    setselectedRecord(record.record_info[index]);
                    setAction('view');
               }
               dispatch(setLoading(false));
          } catch (e: any) {
               dispatch(setLoading(false));
          }
     }

     /**
* partial modify the data
*/
     const onPartialModify = (record: any = null, index: any = null) => {
          props.formData.isPartialModify = true;
          const state = { data: props.formData, projectData: props.projectData, selectedValues: record.fields, id: record.id, moduleType: "dataEntry", modifyType: "modifyPartial" };
          setCustomNavigationState(state);
          setAction("navigateToDataEntry");
     }

     const onModify = async (record: any = null, index: any = null) => {
          let dataObj: any = props.formData;
          dataObj.projectData = props.projectData;
          const responseId = record?.record_info[index]?.id || responseData[selectedIndexData]?.id;
          if (record) {
               try {
                    let responseForm = await getFormData(record.form_id);
                    if (responseForm) {
                         let dataCurObj = responseForm.data;
                         dataCurObj.isMaster = true;
                         dataCurObj.masterData = mdata;
                         dataCurObj.projectData = props.projectData;
                         const state = { data: dataCurObj, projectData: props.projectData, selectedValues: record.record_info[index].fields, id: record.id, isMaster: true, moduleType: "dataEntry", modifyType: "modify", responseId: responseId };
                         setCustomNavigationState(state);
                         setAction("navigateToDataEntry");
                    }
               } catch (error) {

               }
          } else if (isMasterData) {
               try {
                    let responseForm = await getFormData(masterresponseData.form_id);
                    if (responseForm) {
                         let dataCurObj = responseForm.data;
                         dataCurObj.masterData = mdata;
                         dataCurObj.isMaster = true;
                         dataCurObj.projectData = props.projectData;
                         const state = { data: dataCurObj, projectData: props.projectData, selectedValues: masterresponseData.record_info[selectedIndexData].fields, id: masterresponseData.record_info[selectedIndexData].id, isMaster: true, moduleType: "dataEntry", modifyType: "modify", responseId: responseId };
                         setCustomNavigationState(state);
                         setAction("navigateToDataEntry");
                    }
               } catch (error) {

               }
          } else {
               dataObj.isMaster = true;
               dataObj.masterData = mdata;
               const state = { data: dataObj, projectData: props.projectData, selectedValues: isMasterData ? responseData[0] : responseData[selectedIndexData].fields, id: isMasterData ? responseData[0].id : responseData[selectedIndexData].id, moduleType: "dataEntry", modifyType: "modify", responseId: responseId };
               setCustomNavigationState(state);
               setAction("navigateToDataEntry");
          }
     }


     return (
          <>
               {action === 'view' && <ViewForm {...props} projectData={props.projectData} selectedRecord={selectedRecord} variables={formVariables} formData={formData} modify={onModify} partialModify={onPartialModify} permissionData={props.permissionData} onClose={() => setAction('')} />}
               {action === "navigateToDataEntry" && <SurveyFormComponent {...customNavigationState} onClose={() => setAction("")} />}
               {action === "dump" &&
                    <Dump
                         masterUidData={masterUidData}
                         formData={selectedFormData}
                         projectData={projectData}
                         onClose={() => setAction("")}
                    />
               }
               {action === "" && <div className="master-data-container">
                    {/* <div className="header-container">
                         <Row className='m-0'>
                              <Col className='pl-4 mt-3' md={10}>
                                   <div className='form-name'>{projectData?.topicdesc}</div>
                              </Col>
                              <Col className='pr-4 mt-4 text-right' md={2}>
                                   <i className='icon icon-close' onClick={() => props.onClose()} />
                              </Col>
                         </Row>
                    </div> */}
                    <div className="top-bar">
                         <div className={window.innerWidth > 750 ? "page-header-style" : "page-header-data-style"}>
                              <div className={window.innerWidth > 750 ? "project-title" : "project-title-mob"}>
                                   <ArrowLeftOutlined style={{ color: "#fff", fontSize: "36px", margin: "0px 10px" }} onClick={() => props.onClose()} />
                                   <div className="title">
                                        {projectData?.TopicDesc || projectData?.topicdesc}
                                   </div>
                              </div>
                         </div>
                    </div>
                    <div className="master-body">
                         <div className="master-head">
                              <Row>
                                   <Col md={4}>Form Name</Col>
                                   <Col md={2}>Record Counts</Col>
                                   <Col md={6}>Record Info</Col>
                              </Row>
                         </div>

                         <div className="master-data">
                              {
                                   mdata && mdata.map((item, index) => {
                                        return (
                                             <div className="data-item">
                                                  <Row>
                                                       <Col md={4}>
                                                            <div className="form-name-val">
                                                                 {item?.form_name}
                                                            </div>
                                                       </Col>
                                                       <Col md={2}>
                                                            <div className="form-count">
                                                                 {item?.count_info.length > 0 ? item?.count_info[0]['totalRecords'] : 0}
                                                            </div>
                                                       </Col>
                                                       <Col md={6}>
                                                            <div className="record-data">
                                                                 {
                                                                      props.selectedIndexData?.checkMandatory ?
                                                                           item.form_use_category && item.form_use_category.includes('MANDATORY') ?

                                                                                item.record_info.length > 0 ?
                                                                                     (
                                                                                          item.record_info.map((itm, x) => {
                                                                                               return <div className="data-info" key={itm.id}>
                                                                                                    <b style={{ padding: "1px 5px" }}>Created At: </b> <span>{formatDate(itm.created_at)}</span>
                                                                                                    <div className="add-itm" onClick={() => onAddAction(item)}>Add</div>
                                                                                                    <div className="view-itm" onClick={() => onViewAction(item, x)}>View</div>
                                                                                                    <div className="edit-itm" onClick={() => onModify(item, x)}>Edit</div>
                                                                                                    <div className="dump-itm" onClick={() => dumpAction(item)}>Dump</div>
                                                                                               </div>
                                                                                          })

                                                                                     )
                                                                                     :
                                                                                     <div className="data">
                                                                                          <div className="add-itm" onClick={() => onAddAction(item)}>Add</div>
                                                                                          <div className="dump-itm" onClick={() => dumpAction(item)}>Dump</div>
                                                                                     </div>
                                                                                :
                                                                                ""
                                                                           :
                                                                           item.record_info.length > 0 ?
                                                                                (
                                                                                     item.record_info.map((itm, x) => {
                                                                                          return <div className="data-info">
                                                                                               <b style={{ padding: "1px 5px" }}>Created At: </b> <span>{formatDate(itm.created_at)}</span>
                                                                                               <div className="add-itm" onClick={() => onAddAction(item)}>Add</div>
                                                                                               <div className="view-itm" onClick={() => onViewAction(item, x)}>View</div>
                                                                                               <div className="edit-itm" onClick={() => onModify(item, x)}>Edit</div>
                                                                                               <div className="dump-itm" onClick={() => dumpAction(item)}>Dump</div>
                                                                                          </div>
                                                                                     })

                                                                                )
                                                                                :
                                                                                <div className="data">
                                                                                     <div className="add-itm" onClick={() => onAddAction(item)}>Add</div>
                                                                                     <div className="dump-itm" onClick={() => dumpAction(item)}>Dump</div>
                                                                                </div>
                                                                 }
                                                            </div>
                                                       </Col>
                                                  </Row>
                                             </div>
                                        )
                                   })
                              }
                         </div>

                    </div>
               </div>}
          </>

     )
}

export default MasterData;